<template>
  <div>
    <modal :modal-key="'bundle-discount'"
           :class-style="'modal--welcomeback'" :body-style="'bonus_content'"
           @close="$emit('close')">
      <template slot="header">
        <h1>{{ getTranslations.home_bundle_discount_header}}</h1>
        <br>
        <img class="pinicon" src="static/images/bonus_phase_discount.svg" alt="">
      </template>
      <template slot="body">
        <h2 class="modal_sub">{{ getTranslations.home_bundle_amount_of_games }}</h2>
        <p>{{ getTranslations.home_bundle_discount_duration }}</p>
        <div class="bonus_phase_timer">
          <h1 v-if="counter">{{ counter }}</h1>
        </div>
        <p class="modal_prg">{{ getTranslations.home_bundle_discount_between_part_1 }}
          {{ dateStart }} - {{ dateEnd }}
          {{ getTranslations.home_bundle_discount_between_part_2 }}</p>
        <p class="modal_prg">{{ getTranslations.home_bundle_discount_purchase_bundles }}</p>
      </template>
      <template slot="footer">
        <a style="cursor:pointer" @click.prevent="goToStorePage" class="btn2 btn2_modal btn2--std btn2--small">
          {{ getTranslations.home_bundle_discount_store }}</a>
      </template>
    </modal>
  </div>
</template>

<script>
// modal_bundle_discount.html
import { mapGetters, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import Modal from '@/components/home/modals/shared/GenericModal';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'bundle-discount',
  data() {
    return {
      timer: 0,
      counter: '',
      dateStart: null,
      dateEnd: null,
    };
  },
  components: {
    Modal,
  },
  beforeDestroy() {
    this.storeModalForHomePage(null);
    this.clearPhaseBonusModalToBeDisplayed();
  },
  created() {
    moment.locale('EN');
    this.dateStart = moment(this.phaseBonusModalToBeDisplayed.start).format('hh:mm:ss');
    this.dateEnd = moment(this.phaseBonusModalToBeDisplayed.end).format('hh:mm:ss');
    const interval = 1000; // every 1 second
    let duration;
    // get time element
    // calculate difference between two times
    const eventTime = moment(this.phaseBonusModalToBeDisplayed.end);
    // loop to countdown every 1 second
    this.timer = setInterval(() => {
      // based on time set in user's computer time / OS
      const currentTime = moment(new Date());
      // get duration between two times
      duration = moment.duration(eventTime.diff(currentTime));
      // get updated duration
      duration = moment.duration(duration - interval, 'milliseconds');

      // if duration is >= 0
      if (currentTime.isAfter(eventTime)) {
        clearInterval(this.timer);
        // hide the countdown element
        this.counter = '';
        this.phaseBonusModalToBeDisplayed.active = false;
      } else {
        // otherwise, show the updated countdown
        this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
      }
    }, interval);
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'clearPhaseBonusModalToBeDisplayed',
    ]),
    goToStorePage() {
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'phaseBonusModalToBeDisplayed',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/BundleDiscount.vue